import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[grid-body-list-row-template]',
  standalone: false,
})
export class GridBodyListRowTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}
